import React from "react";
import Localize from "./Localize/Localize";
import DiamondIcon from "./DiamondIcon";
import "./CurrencyAmount.css";

// Currency types grouped by the symbol they are shown with (see Currency.CurrencyType on the
// backend). Anything else falls back to spelling the currency name out.
const MONEY_CURRENCIES = ["RealMoney", "BonusMoney"];
const DIAMOND_CURRENCIES = ["Diamond", "BonusDiamond"];

/**
 * An amount rendered as "<sign><symbol><number>", the way the in-game balance popup shows it.
 *
 * Pass showSign={false} for figures that are not balance movements (an invoice total, say), where a
 * leading "+" would just be noise.
 */
const CurrencyAmount = ({ amount, currencyType = "", showSign = true }) => {
  const value = parseFloat(amount);
  if (isNaN(value)) return <span>--</span>;

  // The sign goes in front of the symbol, so it is taken off the number and emitted on its own.
  const sign = value > 0 ? "+" : value < 0 ? "-" : "";
  const signSlot = showSign ? <span className="currency-amount-slot">{sign}</span> : null;

  const absolute = Math.abs(value);

  if (MONEY_CURRENCIES.includes(currencyType)) {
    return (
        <span className="currency-amount">
          {signSlot}
          <span className="currency-amount-slot">$</span>
          {absolute.toFixed(2)}
        </span>
    );
  }

  if (DIAMOND_CURRENCIES.includes(currencyType)) {
    return (
        <span className="currency-amount">
          {signSlot}
          <span className="currency-amount-slot"><DiamondIcon /></span>
          {absolute.toLocaleString('en-US')}
        </span>
    );
  }

  // No symbol to fit in a slot for this one, so the name goes after the number.
  const currencyKey = `LANDING_TRANSACTION_CURRENCY_${currencyType.toUpperCase()}`;
  const currencyName = Localize.translate(currencyKey, { defaultValue: currencyType });

  return (
      <span className="currency-amount">
        {signSlot}
        {`${absolute.toLocaleString('en-US')} ${currencyName}`.trim()}
      </span>
  );
};

export default CurrencyAmount;
